import Responsive from './Responsive';
import SmoothScroll from './SmoothScroll';
import Accordion from './Accordion';
import Tab from './Tab';
import SpNavi from './SpNavi';
import ToTop from './ToTop';
import DropDownMenu from './DropDownMenu';
import BlockLink from './BlockLink';
import Gmap from './Gmap';
import FloatAnimation from './FloatAnimation';
import bowser from 'bowser'
import Jqueryinview from "jquery-inview";
import swiper from 'swiper'

if(bowser.msie === true) {
  $('body').addClass('ie');
}else if(bowser.msedge === true){
  $('body').addClass('edge');
}else if(bowser.firefox === true){
  $('body').addClass('ff');
}else if(bowser.tablet === true){
  $('body').addClass('tablet');
}
if(bowser.mobile === true){
  $('body').addClass('device--mobile');
  if(bowser.android === true) {
    $('body').addClass('device--mobile--android');
  }
}

let os, ua = navigator.userAgent;
if (ua.match(/Win(dows )?NT 10\.0/)) {
  os = "win10";
}
else if (ua.match(/Win(dows )?NT 6\.3/)) {
  os = "win8_1";
}
else if (ua.match(/Win(dows )?NT 6\.2/)) {
  os = "win8";
}
else if (ua.match(/Win(dows )?NT 6\.1/)) {
  os = "win7";
}else{
  os = '';
}

$('body').addClass(os);
/* ===============================================
Check responsive state
=============================================== */
const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
// 	console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());
/* ===============================================
SP Navi
=============================================== */
const _sp_nav_accordion = function(scroller){
	$(".js-toggle-nav" ).off('click');
	$(".js-toggle-nav" ).on("click",function() {
		let $child = $(this).next('.child');
		let status = $child.css('display');
		if(status == 'block'){
			$child.slideUp(300,function(){
				scroller.refresh();
			});
			$(this).removeClass('active')
		}else{
			$child.slideDown(300,function(){
				scroller.refresh();
			});
			$(this).addClass('active')
		}

		return false;
	});
}
let param = {
	target:'#spnavi',
	trigger:'.btn_sp_navi',
	filter:'resposive_flg',
	speed:200
};
const spnavi = new SpNavi(param);
spnavi.exec(_sp_nav_accordion);
/* ===============================================
box link
=============================================== */
// let box_link = new BlockLink();
// box_link.exec('.box_link');
/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
const totop = new ToTop('#totop',100,400);
totop.exec();
/* ===============================================
DropDown

markp:
<ul>
	<li>
		<a href=""></a>
		<ul class="child">
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
		</ul>
	</li>
	<li>
		<a href=""></a>
	</li>
	<li>
		<a href=""></a>
	</li>
</ul>
=============================================== */
// const dd = new DropDownMenu('ul li','.child',200);
// dd.exec();
/* ===============================================
Accordion

markp:
<dl>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
</dl>
=============================================== */
// const ac = new Accordion($('dt'));
// ac.exec();
/* ===============================================
Tab

markup:
<div class="tc">
	<ul>
		<li>tab1</li>
		<li>tab2</li>
		<li>tab3</li>
	</ul>
	<div class="tc_content">
		tabcon1tabcon1tabcon1tabcon1tabcon1tabcon1
	</div>
	<div class="tc_content">
		tabcon2tabcon2tabcon2tabcon2tabcon2tabcon2
	</div>
	<div class="tc_content">
		tabcon3tabcon3tabcon3tabcon3tabcon3tabcon3
	</div>
</div>
=============================================== */
// const tab = new Tab('.tc li','.tc .tc_content');
// tab.exec();

// /* gmap
// ----------------------- */
// let gmap = new Gmap();
// $(window).on('load',function(){
// 	gmap.exec();
// });

/* ===============================================
#	home slider swiper
=============================================== */
var mySwiper = new Swiper('.swiper-container', {
	loop: true,
	speed:500,
	autoplay:3000,
	effect:"fade"
});


/* ===============================================
#	inview animation
=============================================== */
function anim1(){
	var tl = new TimelineMax();

}

(function($) {
$(function(){
	$('.js-inview--stager_wrapper').on('inview',function(event, isInView, visiblePartX, visiblePartY){
		if(!$(this).hasClass('animated')){
			let float_animation = new FloatAnimation($(this).find('.js-inview--stagger'),'bottom');
			float_animation.animateStagger($(this),0.2);
			float_animation = null;
		}
	});
});
})(jQuery);

/* ===============================================
#	gnav
=============================================== */
(function($) {
$(function(){
	$( ".mod-has-child" ).hover(function() {
		$(this).find(".child").stop().fadeIn();
	}, function() {
		$(this).find(".child").stop().fadeOut();
	});
});
})(jQuery);

/* ===============================================
#	faq
=============================================== */
(function($) {
$(function(){
	$(".faq-q").on("click",function(){
		$(this).toggleClass("active");
		$(this).next().slideToggle().toggleClass("active");
	});
});
})(jQuery);

/* ===============================================
#	recruitment tab
=============================================== */
(function($) {
$(function(){
	$(".tab-item").on("click",function(){
		$(".tab-item").removeClass("active");
		$(this).addClass("active");
		var num = $(this).index();
		// console.log(num);

		//表の切り替え
		$(".table-tab-wrap table").removeClass("active");
		$(".table-tab-wrap table").eq(num).addClass("active");

		//キャリアアップの切り替え
		$(".cont-tab").removeClass("active");
		$(".cont-tab").eq(num).addClass("active");
	});
});
})(jQuery);

/* ===============================================
#	gnav recruitment tab
=============================================== */
(function($) {
	$(function(){
		const hash = location.hash;
		console.log(hash);
		if(hash == "#regular"){
			$(".tab-item").removeClass("active").eq(1).addClass("active");;
			$(".table-tab-wrap table").removeClass("active").eq(1).addClass("active");
			$(".cont-tab").removeClass("active").eq(1).addClass("active");
		}
	});
})(jQuery);


// WEBPACK FOOTER //
// ./dev/js/scripts/main.js